import * as Sentry from '@sentry/browser';
import {
    OPERATION_SOFTWARE_ID,
    OPERATION_NAME_FIELD,
    OPERATION_FIELD,
    NO_OPERATION_CIRIL_SOFTWARE_ID_VALUE,
} from 'routes/BudgetModule/config/constants';
import { OperationT } from 'routes/BudgetModule/config/types';

const CAMEL_SOFTWARE_ID = OPERATION_SOFTWARE_ID;
const CAMEL_NAME = OPERATION_NAME_FIELD;
const CAMEL_CODE = OPERATION_FIELD;

/*
 * If null operation is not operations list, we had it manually
 * So that the user can de-assign an operation
 * Null Operation represents operation "NO_OPERATION"
 */
export const addNullOperation = (operations: OperationT[]): OperationT[] => {
    const hasNullOperation = operations.some((operation) =>
        // FIXME: Ciril part to remove once the Ciril NULL operation has been deleted
        ['', NO_OPERATION_CIRIL_SOFTWARE_ID_VALUE].includes(
            operation[CAMEL_SOFTWARE_ID],
        ),
    );
    return !hasNullOperation
        ? [
              ...operations,
              {
                  [CAMEL_SOFTWARE_ID]: '',
                  [CAMEL_NAME]: '',
                  [CAMEL_CODE]: '',
              },
          ]
        : operations;
};

export const getOperationNameFromSoftwareId = (
    softwareId: string,
    operations: OperationT[],
    chooseValueLabel: string,
): string => {
    if (softwareId === '') return chooseValueLabel;
    const operation = operations.find(
        (op) => op[CAMEL_SOFTWARE_ID] === softwareId,
    );
    if (!operation) {
        Sentry.captureException(
            new Error(
                `Operation ${softwareId} not found we should check what is happening`,
            ),
        );
        return chooseValueLabel;
    }
    return operation[CAMEL_NAME];
};
